/** Wire types — identical to the mobile app and backend/src/modules/sync/schemas.ts. */

export type Category = {
  id: string;
  parentId: string | null;
  name: string;
  icon: string;
  color: string;
  sortOrder: number;
  isDefault: boolean;
  isArchived: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
};

export type Expense = {
  id: string;
  categoryId: string;
  amountMinor: number;
  currency: string;
  title: string;
  merchant: string | null;
  paymentMethodId: string | null;
  notes: string | null;
  expenseDate: string;
  expenseTime: string | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
};

export type ReceiptMeta = {
  id: string;
  expenseId: string;
  mimeType: string;
  fileSize: number;
  width: number | null;
  height: number | null;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  version: number;
};

export type User = {
  id: string;
  phone: string;
  firstName: string;
  lastName: string;
  currency: string;
  timezone: string;
  hasPin: boolean;
};

export type Versioned<T> = T & { version: number };

export type PullPage = {
  categories: Versioned<Category>[];
  expenses: Versioned<Expense>[];
  receipts: ReceiptMeta[];
  cursor: number;
  hasMore: boolean;
};

export const PAYMENT_METHODS = [
  { id: 'cash', name: 'Cash' },
  { id: 'upi', name: 'UPI' },
  { id: 'debit_card', name: 'Debit Card' },
  { id: 'credit_card', name: 'Credit Card' },
  { id: 'bank_transfer', name: 'Bank Transfer' },
  { id: 'other', name: 'Other' },
];

/** Same ids as the mobile seed, so web-first and phone-first accounts converge. */
export const DEFAULT_CATEGORIES: Pick<Category, 'id' | 'name' | 'icon' | 'color'>[] = [
  { id: 'food', name: 'Food', icon: 'utensils', color: 'amber' },
  { id: 'transport', name: 'Transport', icon: 'bus', color: 'blue' },
  { id: 'shopping', name: 'Shopping', icon: 'shopping-bag', color: 'violet' },
  { id: 'bills', name: 'Bills', icon: 'receipt', color: 'orange' },
  { id: 'health', name: 'Health', icon: 'heart-pulse', color: 'rose' },
  { id: 'entertainment', name: 'Entertainment', icon: 'clapperboard', color: 'pink' },
  { id: 'education', name: 'Education', icon: 'graduation-cap', color: 'indigo' },
  { id: 'travel', name: 'Travel', icon: 'plane', color: 'cyan' },
  { id: 'subscriptions', name: 'Subscriptions', icon: 'repeat', color: 'teal' },
  { id: 'family', name: 'Family', icon: 'users', color: 'green' },
  { id: 'other', name: 'Other', icon: 'circle-ellipsis', color: 'slate' },
];
